<yds-modal [open]="open()" [title]="'Kopiëren Exportdefinitie'" size="md" (close)="onCancel()">
  <form class="edc-form" [formGroup]="form">
    <p class="gl-form__required-hint">
      Velden gemarkeerd met een sterretje
      (<span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>) zijn verplicht
    </p>

    <section class="edc-block">
      <h3 class="edc-block__title">Origineel</h3>

      <div class="gl-field">
        <div class="gl-field__control">
          <yds-combobox
            formControlName="sourceCode"
            [label]="'Exportdefinitie (origineel)'"
            [items]="sourceComboOptions()"
            [required]="true"
            [allowClear]="false"
            [hasError]="isInvalid(form.get('sourceCode'))"
            [errorMsg]="'Exportdefinitie (origineel) is verplicht.'"
            [placeholder]="'Selecteer een exportdefinitie'"
          />
        </div>
      </div>
    </section>

    <section class="edc-block">
      <h3 class="edc-block__title">Kopie</h3>

      <div class="gl-field">
        <div class="gl-field__control">
          <yds-text-field
            formControlName="newName"
            [label]="'Exportdefinitie (kopie)'"
            [required]="true"
            [maxLength]="maxNameLength"
            [hasError]="nameTaken() || isInvalid(form.get('newName'))"
            [errorMsg]="
              nameTaken()
                ? 'Deze exportdefinitie bestaat al. Kies een andere naam.'
                : 'Exportdefinitie (kopie) is verplicht.'
            "
            [placeholder]="'Vul een naam voor de kopie in'"
          />
        </div>
      </div>

      <div class="gl-field">
        <div class="gl-field__control">
          <yds-combobox
            formControlName="tenantCode"
            [label]="'Doelgroep (kopie)'"
            [items]="tenantComboOptions()"
            [allowClear]="false"
            [placeholder]="'Selecteer een doelgroep'"
          />
        </div>
      </div>
    </section>
  </form>

  <div footer class="edc-footer">
    <yds-button variant="default" (click)="onCancel()">Annuleren</yds-button>
    <yds-button variant="primary" [disabled]="!canCopy()" (click)="onCopy()">Kopiëren</yds-button>
  </div>
</yds-modal>
